import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed odit aliquam libero, soluta unde eum ex blanditiis! Est officia optio repellat itaque quisquam exercitationem asperiores facilis, et similique excepturi dolores! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, _toDisplayString(`${_ctx.job.title} - ${_ctx.job.salary} ${_ctx.job.bonus}`), 1),
    _hoisted_1
  ], 64))
}